// field Id's, these match the id's used on the server as well as the param names.
export const PORTAL = "Portal";
export const PORTAL_REGION = "PortalRegion";
export const EMAIL_TYPE = "EmailType";
export const FROM_DATE = "From";
export const TO_DATE = "To";
export const EMAIL_ADDRESS = "EmailAddress";
export const STATUS = "Status";

export const fieldIds = {
  PORTAL,
  PORTAL_REGION,
  EMAIL_TYPE,
  FROM_DATE,
  TO_DATE,
  EMAIL_ADDRESS,
  STATUS,
};

export enum EmailTypes {
  ApprovedRegistration = "ApprovedRegistration",
  RejectedRegistration = "RejectedRegistration",
  PortalAccessRequestApproval = "PortalAccessRequestApproval",
  PortalAccessRequestRejection = "PortalAccessRequestRejection",
  ChangeEmailAddressRequestApproval = "ChangeEmailAddressRequestApproval",
  ChangeEmailAddressRequestRejection = "ChangeEmailAddressRequestRejection",
}
